/* DataFast goal tracking utility
   Created: Provides a safe wrapper for DataFast custom event tracking.
   Use trackGoal('goal_name') for programmatic events (form submissions, async actions).
   Use data-fast-goal="goal_name" HTML attribute for click tracking on buttons/links. */

declare global {
  interface Window {
    datafast?: (event: string, data?: Record<string, unknown>) => void;
  }
}

export function trackGoal(goalName: string, data?: Record<string, unknown>): void {
  try {
    if (typeof window !== 'undefined' && typeof window.datafast === 'function') {
      window.datafast('event', { goal: goalName, ...data });
    }
  } catch {
    // Silently fail - analytics should never break the app
  }
}
